import React, { useEffect, useState } from "react";
import PortfolioCard from "./PortfolioCard";
import { useOpportunity } from "../../../Providers/OpportunityContext";
import { shortNumber } from '../../../Utils/Utils';
import { useNavigate } from "react-router-dom";
import { getCustomerDetails } from "../../../Services/clientService";

const PortfolioCards = (props) => {
	const [customer, setCustomer] = useState(null)
	const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
	const [customerShort, setCustomerShort] = useState(null)
	const navigate = useNavigate()
	const getCustomerData = async (id) =>{
		const customerData = await getCustomerDetails(id);
		if(customerData && customerData.data){
			setCustomerShort(customerData.data.customer_short)
		}
	}
	useEffect(()=>{
		const endUser = localStorage.getItem('enduser')
		if(endUser){
			const customerData = JSON.parse(endUser)
			getCustomerData(customerData.customer)
			setCustomer(customerData)
		}else{
			navigate("/login")
			localStorage.clear()
		}
	},[])

	return (
		<div className="portfolio">
			{
				props.isMultiBox &&
				<div className="portfolio-cards">
					<PortfolioCard
						progressBar={true}
						title={props.winScore.sustainScore}
						progressStatus={props.color}
						progressPercentage={globalOpportunityData.win_score}
					></PortfolioCard>
					<PortfolioCard
						progressBar={true}
						title={props.winScore.riskScore}
						progressStatus={props.riskColor}
						progressPercentage={props.riskScores['riskSum']}
					></PortfolioCard>
					<PortfolioCard
						progressBar={true}
						title={props.winScore.ESGScore}
						progressStatus={props.colorRDSStatus}
						progressPercentage={props.rdsScore}
					></PortfolioCard>
					<PortfolioCard
						progressBar={true}
						title={props.winScore.opportunityScore}
						progressStatus={props.riskOppColor}
						progressPercentage={props.riskScores['riskOppSum']}
					></PortfolioCard>
					<PortfolioCard
						progressBar={false}
						title={customerShort != undefined && customerShort === process.env.REACT_APP_BAXALL ? 'Contract Value': "Budget Value"}
						costValue={!isNaN(props.opportunityData.total_contract_value?.text) ? props.currency + ' ' + shortNumber(props.opportunityData.total_contract_value?.text) : ''}
						sectionPermissions={props.sectionPermissions}
						pendingResponsibility={props.pendingResponsibility}
					></PortfolioCard>
				</div>
			}
			{
				props.isSingleBox &&
				<div className="portfolio-cards">
					<PortfolioCard
						progressBar={true}
						title={props.winScore.sustainScore}
						progressStatus={props.color}
						progressPercentage={props.opportunityData.win_score}
					></PortfolioCard>
				</div>
			}
		</div>
	);
};

export default PortfolioCards;
